import { Button } from '@/components/ui/button';
import { WalletConnectDappData } from './types';

type ConnectedDappsSectionProps = {
  dappData: WalletConnectDappData[];
  onDisconnect: (topic: string) => Promise<void>;
};

/**
 * List display of connected dapps via WalletConnect with a button to disconnect from each
 */
export function ConnectedDappsSection({
  dappData,
  onDisconnect,
}: ConnectedDappsSectionProps): React.ReactElement {
  return (
    <div className="flex w-full max-w-[479px] flex-col gap-[12px]">
      <p className="text-center text-[14px] font-normal leading-[20px] text-black">
        Connected Dapps
      </p>
      {dappData.map((dapp) => (
        <div
          key={dapp.topic}
          className="flex items-center justify-between rounded-[20px] border border-zinc-200 bg-zinc-50 px-[20px] py-[30px] my-[10px]"
        >
          <div className="flex items-center gap-[15px]">
            {dapp.imageUri ? (
              <img
                src={dapp.imageUri}
                alt={dapp.name || 'dApp icon'}
                className="h-[57px] w-[57px] rounded-full object-cover"
              />
            ) : (
              <div className="flex h-[57px] w-[57px] items-center justify-center rounded-full bg-zinc-200 text-[16px] font-medium text-zinc-700">
                {(dapp.name || 'D').charAt(0).toUpperCase()}
              </div>
            )}
            <div className="flex flex-col gap-[5px]">
              <p className="text-[20px] font-medium leading-[20px] text-zinc-700">
                {dapp.name || 'Unknown dApp'}
              </p>
              {dapp.dappUri ? (
                <a
                  href={dapp.dappUri}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[14px] font-normal leading-[20px] text-zinc-500 underline"
                >
                  {dapp.dappUri}
                </a>
              ) : (
                <p className="text-[14px] font-normal leading-[20px] text-zinc-500 underline">
                  No website available
                </p>
              )}
            </div>
          </div>
          <Button
            className="h-[40px] rounded-[62px] bg-neutral-800 px-[16px] py-[8px] text-[16px] font-medium leading-[24px] text-white hover:bg-neutral-700"
            onClick={() => onDisconnect(dapp.topic)}
          >
            Disconnect
          </Button>
        </div>
      ))}
    </div>
  );
}
